import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import { MultiClamp } from '../utils';

var Measure = /*#__PURE__*/function (_PureComponent) {
  _inherits(Measure, _PureComponent);

  var _super = _createSuper(Measure);

  function Measure() {
    var _this;

    _classCallCheck(this, Measure);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "update", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          paragraphRef = _assertThisInitialize.paragraphRef,
          _assertThisInitialize2 = _assertThisInitialize.props,
          children = _assertThisInitialize2.children,
          ellipsis = _assertThisInitialize2.ellipsis; // 只有纯文本才进行字符串截取操作


      if (typeof children !== 'string') return;
      paragraphRef.innerText = children;
      new MultiClamp(paragraphRef, ellipsis);
    });

    return _this;
  }

  _createClass(Measure, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.update);
      this.update();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.update);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          _this2.paragraphRef = el;
        },
        className: classNames('jmtd-typography-paragraph', 'jmtd-typography-paragraph-multiple', className)
      }, children);
    }
  }]);

  return Measure;
}(PureComponent);

Measure.propTypes = {
  className: PropTypes.string,
  ellipsis: PropTypes.object
};
Measure.defaultProps = {
  className: '',
  ellipsis: {}
};
export default Measure;